module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap-num"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("Chapter One")]), _vm._v(" "), _c('h2', {
    staticClass: "chap-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Prelude to the Final Solution")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("W")]), _vm._v("hen the Nazis conquered Poland at the end of September 1939, the Germans acquired territory with a population of 20 million, of whom 17 million were Poles and 675,000 Germans. Before invading, Hitler had already decided that he would clear the Poles and Jews out of the incorporated areas and replace them with German settlers. What followed was a period of unrestrained terror in Poland, particularly in the incorporated territories. The unincorporated areas, consisting of the province of Lublin and parts of the provinces of Warsaw and Krakow, contained a population of 11 million. It was initially termed the ‘General Government of the Occupied Polish Areas’ and in 1940 was renamed the ‘General Government’. It became the dumping ground for all undesirables and those deemed enemies of the state. It was here that the first deportations of Poles and Jews were sent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In early 1940 the General Government absorbed many thousands of people. Relocating Poles and Jews became an administrative nightmare and it was agreed that the Jews should be forced to live in ghettos. This would not only relieve the burden of the resettlement programme, but it was a way of temporarily getting rid of the ‘Jewish problem’. The Nazis propagated the belief that the Eastern Jews in particular were carriers of disease and needed to be isolated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meanwhile, the SS pursued harsh policies to deal with the threat of subversion by Polish nationalists and Jewish Bolshevists in the newly incorporated territories. By early 1940 the various detention centres of the Reich had become full to bursting due to the large numbers deemed enemies of the state. News circulated through SS channels that government officials were demanding immediate action in the expansion of the concentration camp system through its new conquered territory, Poland. The German authorities quickly pressed forward to establish camps in Poland where prisoners could be incarcerated and set to work as stonebreakers and construction workers for buildings and streets. It was envisaged that the Poles would remain as a slave labour force, and ‘quarantine camps’ were established to subdue the local population.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Initially it was proposed that the quarantine camps would hold the prisoners until they were sent to concentration camps in the Reich. But it soon became apparent "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("that this was impractical, and it was approved that these camps were to function as permanent prisons. Throughout 1940 the SS concentration camp system in Poland expanded rapidly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While the Jews were imprisoned in ghettos, the Germans invaded the Soviet Union and the Jewish problem escalated further as thousands of Jews and other creeds regarded by the Nazis as ‘subhuman’ entered the area controlled by the Reich.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although shooting was effective as a method of killing, commanders soon became aware it had disadvantages. Firstly, the killings were difficult to conceal and were often witnessed by unauthorized persons, who often complained at the brutality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Secondly it was distressing for the killers. Himmler was aware of the problems of mass execution. In August 1941 near Minsk he witnessed a mass killing and nearly fainted. He commented to a commander that the execution was not humane and the effects on the troops would lower morale. Meanwhile he told the army that they would have to accept the liquidations in the East as policy as it was a matter of ideology.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One idea was to get other people to do the killing: Poles, Ukrainians, Balts, and Jews who were anyway going to be killed. This was better, especially when rounding up and killing women and children. But shooting was still not a fast enough way to kill the huge numbers they wanted to kill. Himmler made it clear he required a more effective method, such as explosives or gas.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gas was not a new method to the Nazis. A special department known as T4 had organized the ‘euthanasia programme’, which used gas to kill the insane and incurably ill. The programme was a success and run for two years, but due to public opinion it was reluctantly suspended. Now it was proposed that this method of killing should be used outside Germany against enemies of the state in the East, and plans were set in motion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gas was introduced for the first time to the killing squads known as Einsatzgruppen. A special airtight vehicle was built to resemble an ambulance. The victims would be placed in the cabin and carbon monoxide pumped in. In the autumn of 1941 the first gas van prepared for the Eastern Front was tested on Russian prisoners of war in Sachsenhausen concentration camp.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although many thousands of Jews and Russians were captured and murdered in the new gas vans, they were still not popular with the SS. But they were to remain the preferred method of killing for the time being.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gas vans were also used near the first extermination centre which was built in the Polish village of Chełmno nad Nerem, 31 miles north of Łódź.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0007-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Two showing the carnage the Nazi wrought on Poland during the invasion of the country in September 1939. By 5 October Poland had surrendered and Hitler was determined to destroy the country politically and racially.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0008-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A Jewish gentleman in the town of Przemyśl on 15 September is being humiliated by a German soldier by cutting some of his beard off. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(ARC)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0008-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A policeman assists the Germans with rounding up Jewish people and those suspected to be members of the intelligentsia and other political prisoners.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0009-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("German soldiers are undertaking house-to-house searches in a Polish town. A Jewish boy has been called out from inside his house and runs out to join other Jews.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0010-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jews being rounded up in Lublin on 3 September.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0010-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Portrait of Hans Frank, the German Governor-General of Poland from 1939 to 1945. After the German invasion of Poland in 1939, Frank was appointed Governor-General of the occupied Polish territories. During his appointment, he instituted a reign of terror against the civilian population and became directly implicated in the mass murder of Jews. He was also responsible for directing orders for the use of forced labour, deportation, helping in the planning for the ghetto system, and oversaw four of the extermination camps.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0011-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("SS-Obergruppenführer Odilo Globocnik, SS and Police Leader for the Lublin district of Poland in November 1939. In May 1942, SS-Reichsführer Heinrich Himmler put him in charge of Operation Reinhard, the plan for the extermination of Polish Jewry utilizing three death camps: Treblinka, Belzec and Sobibor.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0011-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Reinhard Heydrich, a main architect of the Holocaust, chief of the Reich Main Security Office (including the Gestapo, Kripo and SD). He was also deputy Protector of Bohemia and Moravia. Heydrich was instrumental in carrying out plans for the extermination of the Jews in Europe and in the East. It is generally believed that Aktion Reinhard was named after Reinhard Heydrich.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0011-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A photo of SS-Reichsführer Heinrich Himmler (right) of the SS, who was one of the most powerful men in Nazi Germany. He was also the main architect of the Holocaust and directed the murder of millions of innocent people due to his extreme racial and political views.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0012-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Copy of a letter signed by Hitler authorizing the T4 (euthanasia) program. It states: ‘Reichsleiter [Philipp] Bouhler and Dr. med. [Karl] Brandt are charged with responsibility to broaden the authority of certain doctors to the extent that [persons] suffering from illnesses judged to be incurable may, after a humane, most careful assessment of their condition, be granted a mercy death. [signed] Adolf Hitler.’ In 1940, ordered by Himmler, Franz Stangl became superintendent of the T4 Euthanasia Programme at Schloss Hartheim. Here people with mental and physical disabilities, as well as political prisoners, were sent to be killed. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(USHMM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0013-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("SS-Reichsführer Heinrich Himmler of the SS inspects some of his Waffen-SS soldiers. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(NARA)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0013-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jewish people being escorted along a road through a town. Following the German invasion of Poland there was a period of unrestrained terror, particularly in the incorporated territories. Areas not incorporated had a population of some 11 million. It comprised of the Polish province of Lublin and parts of the provinces of Warsaw and Krakow. It was initially termed the ‘General Government of the Occupied Polish Areas’, but in 1940 was renamed the ‘General Government’. This large, unincorporated area was the dumping ground for all undesirables. It was here that the first deportations of Poles and Jews were sent in their thousands. By the end of January 1940, the immense problems of simultaneously attempting to relocate Poles, Jews and the ethnic Germans had become such an administrative nightmare that it was agreed that all Jews should be forced to live in ghettos.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0014-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A group of Jewish men have been rounded up inside a town by German troops. Many of these hapless people were forced into ghettos.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0014-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("German troops on the march during the invasion of Russia in June 1941. It would be here that the population would suffer most at the hands of the Nazis.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0015-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Another photograph showing German troops on the march during the invasion of Russia in June 1941.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0015-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The first of six photographs showing Russian PoWs surrendering to German forces during the invasion of Russia in the summer of 1941. Russian PoWs were used to construct buildings in the death camps, including crematoria and gas chambers.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0016-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0016-02.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0017-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0017-02.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0017-03.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0018-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("German Police interrogate a frightened and bewildered old Jewish gentleman. It is more than likely this photograph was taken during a resettlement action.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0018-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A photograph depicting a liquidation action of a town.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0019-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionl"
  }, [_vm._v("Jewish people have been loaded into one of the many cattle cars in preparation for them to be sent from the ghettos to one of the Reinhardt concentration camps.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0019-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionl"
  }, [_vm._v("An SS officer confers with his staff during a roll call of political and Jewish prisoners in a camp.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0020-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Wearing their distinctive stripy overalls, Jewish men have been selected for forced labour. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum / Yad Vashem / USHMM)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0020-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jewish women have been selected for forced labour at Auschwitz-Birkenau and stand at a roll call in front of the camp’s kitchen. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum / Yad Vashem / USHMM)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0021-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Concentration camp forced labour removing earth for the construction of a building.")])]), _vm._v(" "), _c('h3', {
    staticClass: "sub-title",
    attrs: {
      "id": "ch1_1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Chełmno (Kulmhof) – Killing Centre")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the late summer of 1941, SS-Sturmbannführer Herbert Lange, who had already experienced the mass killings of Poles in mobile gas chambers, orchestrated gassing experiments of some 1,500 Jews in gas vans north-east of Chełmno (renamed Kulmhof by Germans). The gassings were a success and the Nazis looked for a suitable place to build an extermination centre in the area. By October a location had been chosen and Lange was made commandant of the new camp. The following month he was given two vans, nicknamed ‘Kaisers-Kaffee’ vans, manufactured by the Gaubschat factory in Berlin. They had sealed compartments with metal pipes welded below the floor into which the engine exhaust gasses were directed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Chełmno site was situated in a run-down castle on an empty manor house estate. All the inhabitants in the area were removed for secrecy. Initially Lange’s SS-Sonderkommando that would operate the camp consisted of fifteen members of the security police, fifty policemen of the Kompanie des Polizeibataillons Litzmannstadt (Łódź), and some policemen who were given Transport, Castle and Forest Camp duties.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Killing operations began on 8 December 1941 when Kolo and Romani Jews arrived in lorries. They were stripped of their possessions and herded into the mobile gas vans. The van driver, wearing a gas mask, then connected the exhaust pipe to the chamber. After the occupants had died, the driver made his way to the burial pits in the nearby Rzuchów Forest. The corpses were dragged from the vans and thrown into pits and burned by the ‘forest kommando’. The incinerated remains were then covered up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The camp got through six to nine van-loads per day and over a few weeks 3,830 Kolo Jews and 4,000 Romani people were killed this way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of the largest communities to be murdered at the Chełmno killing centre were the residents of the Łódź ghetto. Deportations began on 16 January 1942 and proceeded in phases until 15 May 1942. Some 55,000 Jews from the Łódź ghetto were gassed at Chełmno.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although the killing centre was a success in the eyes of the German authorities, it did not run without incident. One gas van in March 1942 had broken down on a main road with living victims inside. Passers-by heard the cries. It was decided that in future the vans had to be parked while the prisoners were murdered. The following month a van exploded while the driver was revving the engine at the loading bay full of living Jews. The explosion blew off the back doors leaving badly burned and terrified inhabitants inside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chełmno continued to operate through the remainder of 1942 and early 1943, killing more people from the Łódź ghetto and surrounding areas of the Warthe-land District. But other death camps, such as Treblinka, Sobibor and Belzec, had more efficient ways of killing and incinerating people.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("By March 1943 it was agreed that the Chełmno camp should be closed down. An SS order was sent out outlining that all remains were to be exhumed and burned in open-air crematoria by a unit of Sonderkommando 1005. The bones were then crushed by a special machine and the remains gathered in hundreds of sacks which were emptied into a nearby river. Then the manor house was demolished.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In June 1944, as the last part of the Łódź ghetto was liquidated, a special detachment called ‘Bothmann’ returned to its old killing grounds and set up a small camp in the Rzuchów Forest consisting of a wooden barracks and new crematory pyres. Over a month the inhabitants of the Łódź ghetto were sent there where Bothmann resumed killing operations using mobile gas vans. Some 25,000 victims were murdered during this action until it was decided to transport the remaining Łódź Jews to Auschwitz-Birkenau. The camp was then closed down for good.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0023-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jews are being unloaded off a train transport by the deportation police (Evakuierungspolizei) destined for the Chełmno extermination camp.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0024-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jewish deportees from the Łódź ghetto, who have been taken to the Chełmno death camp, are transferred from a closed passenger train to a train of open cars at a station.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0024-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Elderly women carrying young children and bundles of personal belongings trudge along a street in the Łódź ghetto towards the assembly point for deportations to Chełmno. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(USHMM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0025-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jews during a deportation action being sent to a concentration camp.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0025-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Photographed during the Mieędzyrzec Ghetto action are three soldiers and a policeman on the far right. During the two day action around 10,000 Mieędzyrzec Jews were deported to Treblinka.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0026-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A unit of deportation police poses in the Łódź ghetto in the spring of 1942 preparing to ship Jews to Chełmno. The original German caption reads: ‘Evakueringspolizei, spring 1942, #128 [number blurred and hard to read]’. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(USHMM, Robert Abrams)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0026-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jewish men and women prepare to sort clothing confiscated from the deportees to the Chełmno death camp. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(USHMM, Sidney Harcsztark)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0027-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("SS-Hauptscharführer Erwin Burstinge, an SS man on the staff of the Chełmno extermination camp.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0027-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Two SS concentration camp personnel appearing to enjoy the comradeship in their role. For many of the staff working inside these camps, the prestige of the uniform, elitism, toughness, and comradeship often outweighed any morale scruples they had for their hapless inmates. Some almost enjoyed meting out harsh and often brutal punishments for the slightest infractions of camp rules.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0028-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Site at which the SS shot and burned the last forty-five of forty-eight prisoners at Chełmno.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0028-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Here children are seen during a deportation action being led away from Łódź ghetto to the death camp at Chełmno.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0029-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Appearing to enjoy themselves in the summer of 1942 are a group of Polish workmen and SS at Chełmno.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0029-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A post-war photograph showing what a typical mobile gas-van looked like. These vans had sealed compartments with metal pipes welded below the floor into which the engine exhaust was directed. They were tested by the T4 team to ensure there was enough carbon monoxide to kill. However, due to the massive influx of deportees selected to be killed the gas vans could not cope.")])]), _vm._v(" "), _c('h3', {
    staticClass: "sub-title",
    attrs: {
      "id": "ch1_2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Majdanek – Labour & Extermination Camp")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Himmler instructed Odilo Globocnik to find a place to build a camp that could hold at least 25,000 Russian PoWs. By October 1941 a location had been found on the outskirts of Lublin called Majdanek. Unlike other camps this site was not in a remote rural location away from the population, but within the city limits. Due to the large numbers of Russian prisoners captured on the Eastern Front it was agreed to extend the camp to hold 50,000 inmates. This figure then rose to 125,000 in November and then again the following month to 150,000, at which point they envisaged expanding the camp to hold 250,000 Russian PoWs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Work began and by mid-December, with almost half the slave labour force dead, there were barracks for 20,000 people. But after it was big enough to hold 50,000 it was decided to stop because, especially after the Wannsee Conference in January 1942, it was realised that many of those who would enter through the gates at Majdanek would not survive, and it was therefore pointless catering for their needs. In light of this, the camp was refurbished as a killing centre with gas chambers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Majdanek was also used as a sorting and storage facility for the ‘Reinhard death camps’: most of the property and valuables taken from the victims of Sobibor, Treblinka and Belzec were sent to Majdanek to be sorted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At its peak Majdanek boasted seven gas chambers, two wooden gallows, and some 227 structures, placing it among the largest of Nazi concentration camps at that time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the spring of 1942, some 8,500 Slovak Jews and 6,000 Jews from the Protectorate of Bohemia and Moravia, including shipments from Germany and Austria, were sent to Majdanek. It was not until the end of August that the first batch of the poisonous gas was delivered to the camp. A month later, gas chamber operations began. There were two identical buildings in the camp where Zyklon-B was used. Carbon monoxide was also used for killing prisoners.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From October 1942 the camp had a contingent of female personnel, known as overseers. They were notoriously cruel, perhaps because they were eager to show their male SS superiors that they could be as brutal as them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In late 1942, on the orders of Himmler, 35,000 people detained in prisons across the General Government were transported to Majdanek and Auschwitz. The first transport arrived on 7 January 1943 in Lublin. Deportees included political prisoners from Radom, Kielce, Piotrków and Czeęstochowa. At this time the camp held 10,000 prisoners, of which 7,000 were Jews, and another 1,800 were non-Jewish Poles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 27 April 1943 the first transports of Jews from the Warsaw ghetto began arriving, and in June the first transports arrived from Zamosc. The increase in Jewish transports to the camp was in response to ‘Aktion Reinhard’: the three Reinhard camps were becoming overloaded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As plans were put into place to kill most of the inhabitants of the camp, body disposal became the greatest issue. The burning of one batch of corpses in one "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("furnace took about one hour. This was insufficient and the camp authorities sought to build more efficient cremation facilities. Earlier in the year Office C of the WVHA notified the Central Construction Board in Lublin that it would send five furnaces as soon as they had been adapted. By July 1943 building work started. It was completed in late August or early September 1943. The crematorium building comprised an office for the head of the crematorium, a hall for corpses, a room with a concrete autopsy table, a coke storage room, and in the main hall of the building five coke-fuelled furnaces. The company which built them – Kori – boasted that incineration would take only 10–15 minutes in these new furnaces.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A few months later, in early November 1943, the camp’s newly commissioned crematoria were operating at maximum capacity when it began a killing operation known as ‘Harvest Festival’. On one single day, 3 November 1943, 18,400 Jews were murdered. By the end of ‘Harvest Festival’ Majdanek had only 71 Jews left alive out of 6,562 prisoners.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Between December 1943 and March 1944, Majdanek received some 18,000 so-called ‘invalids’, many of whom were gassed on arrival using Zyklon B. Executions by firing squad continued as well, with 600 shot on 21 January 1944, 180 shot two days later, and 200 shot on 24 March 1944.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By mid-July the Red Army was fast approaching Lublin, so an evacuation order was sent out giving instructions to destroy the camp and its murder facilities. However, due to the speed of the Russian advance, and the incompetence of the camp’s deputy commander, Anton Themes, the camp was evacuated virtually intact. Although some 1,000 inmates were marched to Auschwitz, Soviet forces still found thousands of inmates alive when the camp was liberated.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0031-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jewish men being taken to the Majdanek camp, tied together with ropes around their necks.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0032-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Camp entrance gate in 1943 of the Majdanek camp. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Majdanek-State-Museum / Halfen)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0033-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A view of the barracks from a watch tower in Majdanek. In mid-October 1942 the camp held 9,519 registered prisoners, of which 7,468 were Jews, and 1,884 were non-Jewish Poles. By August 1943 this figure had become 16,206 prisoners in the main camp, of which 9,105 were Jews and 3,893 were non-Jewish Poles. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(USHMM, Instytut Pamieci Narodowej)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0033-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("An aerial view of the wooden barracks at Majdanek. At the onset of Operation Reinhard the installation was made into a secondary sorting and storage depot for property and valuables taken from the victims at the killing centres of Belzec, Sobibor, and Treblinka. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(USHMM, Panstwowe Muzeum na Majdanku)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0034-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A view of the double fence that surrounded part of the camp. Image taken after liberation in 1944. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(USHMM, Panstwowe Muzeum na Majdanku)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0035-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A guard post at the entrance to Field III in Majdanek. The camp operated from 1 October 1941 until 22 July 1944 and was virtually intact when the Red Army liberated it. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(USHMM, Instytut Pamieci Narodowej)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0035-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The first of three photographs showing prisoners at forced labour in the Majdanek concentration camp. The images appear to show prisoners constructing the camp. The initial construction phase commenced with 150 Jewish forced labourers from one of Globocnik’s Lublin camps. Later the workforce included 2,000 Russian PoWs. Conditions were so bad that within weeks only 500 were still alive. By mid-December, barracks for 20,000 were ready. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(USHMM, National Archives, Instytut Pamieci Narodowej)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0036-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0036-02.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0037-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A view of the crematoria. In July 1943 building work started on the crematoria and was completed in late August or early September 1943. The main crematorium building consisted of an office for the head of the crematorium, a hall for corpses, a room with a concrete autopsy table, a coke storage room, and in the main hall of the building five coke-fuelled furnaces for incinerating bodies. By November 1943, during Operation Harvest Festival, the crematoria were used at maximum capacity. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(USHMM, Panstwowe Muzeum na Majdanku)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0038-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A view of the crematoria and gas chamber in Majdanek through the barbed wire fence. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(USHMM, unknown Russian archive)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0039-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A photograph showing the gas chambers. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(USHMM, unknown Russian archive)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0039-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A can of Zyklon B used in the mass killing of people in the gas chambers of Auschwitz-Birkenau. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0040-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Majdanek concentration camp, a view from the village Dziesiata. In the background, smoke from burning corpses. Before the crematoria were built, most of the corpses were burnt on huge open pyres that were maintained day and night. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(USHMM, Panstwowe Muzeum na Majdanku)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0040-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A view of the camp after its liberation. In late July 1944, with Soviet forces approaching the area around Lublin, the German staff at Majdanek speedily evacuated the camp. However, the staff had only succeeded in partly destroying the crematoria, leaving virtually all of the camp including the extensive wooden barracks and watch towers intact when Russian soldiers arrived on 24 July 1944. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(USHMM, unknown Russian archive)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0041-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Majdanek concentration camp after liberation. The photograph clearly illustrates the size of the camp with its double high fences and wooden sentry towers. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(USHMM, unknown Russian archive)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0042-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A view of the barracks from a watch tower in Majdanek after its liberation. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(USHMM, Instytut Pamieci Narodowej)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0042-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Rapportführer Hermine Braunsteiner, an SS female guard who was a supervising wardress as Majdanek.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0042-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("This photograph showing the crematorium ovens at the Majdanek concentration camp after the liberation. Note the bones of the victims. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(USHMM, Leopold Page Photographic Collection, Panstwowe Muzeum na Majdanku)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0043-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Six Jewish survivors in front of a crematorium at the Majdanek concentration camp. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(USHMM, Josef Kliger)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0044-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Following the liberation of the camp a Russian soldier takes a photograph of the crematorium ovens with piles of bones in front of them. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(USHMM, Panstwowe Muzeum na Majdanku)")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "sub-title",
    attrs: {
      "id": "ch1_3"
    }
  }, [_vm._v("Auschwitz-Birkenau – Labour & Extermination Camp")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Oswiecim (Oświeęcim) was situated in a remote corner of south-western Poland, in a marshy valley where the Sola River flows into the Vistula about 35 miles west of the ancient city of Krakow. The town was virtually unknown outside Poland and following the occupation of the country Oswiecim was incorporated into the Reich together with Upper Silesia. Here in April 1940 the Nazis built Auschwitz.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Auschwitz was officially a quarantine camp for labour exchange and the nearby town and surrounding area was to be altered beyond recognition. Himmler envisaged that a German settlement at Auschwitz would be built, and from this model town a Germanisation of various villages would be effected.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, for the time being Auschwitz would remain a concentration camp housing a mixture of inmates consisting of Jews, ‘members of the intelligentsia’, resistance and political prisoners, and Polish Catholic priests.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _vm._v("On 1 March 1941 Himmler, with high-ranking SS officers, political leaders of Silesia, and the officers of the giant chemical conglomerate IG Farben met to hear that a site had been chosen for an extension to Auschwitz near the village of Brzezinka, a marshy tract of land surrounded by birch woods about 2 miles west of the main camp. The houses of the village were cleared in July and its inhabitants relocated. The Germans named the area Birkenau.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The task of designing Birkenau was left in the hands of SS-Hauptsturmführer Karl Bischoff, the newly appointed chief of the Auschwitz construction office, and the 33-year-old architect SS-Rottenführer Fritz Ertl. The budget for the construction was to be 8.9 million Reich Marks. The projected number of prisoners to be housed in the camp was 97,000. It was planned that Birkenau would be divided into a two-part camp, with the smaller part of only 17,000 inmates located in a quarantine camp. The inmates were to be packed in, with one barrack block designed to contain 550 inmates. In the end they managed to accommodate 744.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Within weeks Birkenau began taking shape. Some 140,000 cubic feet of earth was excavated, 1,600 concrete foundations laid, 600 concrete posts erected for the fence with 100,000 feet of barbed wire, and 86,000 cubic feet of brickwork using more than a million bricks. The barracks, standard army horse-stable barracks made by a German company, would be produced and dispatched to Auschwitz in kit form. They could be assembled very rapidly by a gang of thirty unskilled men led by one carpenter. In total 253 of these huts were assigned to Birkenau. By the end of 1941 the area had been transformed from a quiet backwater into one of the largest concentration camp systems of the Reich.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To start with Auschwitz was a camp in which Russian PoWs lived and worked. However, soon the Russian PoWs were replaced by Jews, the first transports arriving in February 1942. Those deemed unfit for labour were sent to the new modified gas chamber and murdered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were so many to murder that planners decided to build a new facility at Birkenau. It was proposed that a cottage at the far end of the camp be converted. It was known as Bunker I and nicknamed ‘the little red house’. Its windows and doors were bricked up, cracks were sealed to make it air tight, and the interior gutted to form two rooms. The doors to both rooms had signs over the entrance: ‘Zur Desinfektion’ (to disinfection). Bunker I was to function along similar lines to that of the main camp but on a grander scale. It was completed in a few weeks and on 20 March 1942 it gassed it first Jews – a shipment from Upper Silesia.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Soon plans were made to convert a second cottage, the ‘little white house’, into a ‘bathing facility for special actions’. Bunker II went into operation at the end of June. It consisted of four narrow rooms constructed as gas chambers. With better ventilation and a killing capacity of around 1,200 people a time, Höss, the commandant, was sure that Birkenau would run more efficiently than ever.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _vm._v("However, there was the problem of body disposal. With no proper crematoria yet built, thousands of bodies from both cottages would be collected from the gas chamber entrance, loaded onto trucks and driven to a nearby pit and dumped. But this was soon found to be impractical: there were too many bodies and they could not be buried deep enough. So an improvised crematorium was built and prisoners were forced to dig up the bodies and burn them in the temporary crematorium.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now construction of crematoria began in earnest. The SS brought in eleven construction companies to build them and several hundred workers were allocated to assist. The civilian firm of Huta from Katowice worked on the shell of Crematorium II and then began work on Crematorium IV. The local Auschwitz contractor Koehler worked on the chimneys while Topf and Sons built the furnaces of Crematoriums IV and V. Huta completed the floor and walls of the two underground morgues of Crematorium II, while the Vedag Company from Breslau were paid to waterproof the cellars of Crematorium II and III.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0046-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Showing the infamous gates of ‘Arbeit Macht Frei’ (‘work sets you free’). The commandant of Auschwitz, Rudolf Hoss, firmly believed that inmates gained a sense of discipline by working during their imprisonment, and this discipline would enable them to withstand the harsh environment of prison life. He believed that endless labour brought about a kind of spiritual freedom. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(HITM courtesy of Auschwitz-Birkenau State Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0047-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Taken from within Auschwitz I camp looking out towards the main gate and security office. In 1940, this entrance was where political prisoners would be led through to start their imprisonment. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(HITM courtesy of Auschwitz-Birkenau State Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In March 1943 Crematoria II and IV went into operation and by this time with the growing amount of shipments pouring through to Birkenau there was great urgency to complete the other two crematoria. By the summer of 1943 all of the crematoria were running in spite of some technical issues.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The transports into Birkenau became ever larger, more transports arriving daily through 1943. In the spring of 1944 the numbers arriving at Auschwitz would reach its peak with a huge assignment of Hungarians Jews.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0048-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Showing the high tension electric fence in Auschwitz I with a sign that reads ‘Caution, High Voltage, Danger to Life’. On the left are prisoner blocks and on the right is the commandant’s office, camp administration office and the SS hospital. In 1940, most of the buildings in the camp were intended to house and provide the basic needs for the prisoners, guards and SS staff that ran the camp. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(HITM courtesy of Auschwitz-Birkenau State Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0049-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("At Auschwitz I, showing what one of the three crematoria furnaces looked like during its operation at the camp. The crematoria, known as Crematoria I, operated from 15 August 1940 until July 1943. According to German reports, some 340 corpses could be burned every 24-hours after the installation of the three furnaces. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(HITM courtesy of Auschwitz-Birkenau State Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0049-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("In its present state showing the north-west side of Crematorium I in Auschwitz I. In September 1944, the crematorium was shut down, its chimney removed and was converted into an air raid shelter for the SS hospital. The chimney was rebuilt in 1946/47. Note the steel-faced, gas-tight door with peephole. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(HITM courtesy of Auschwitz-Birkenau State Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0050-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Taken inside one of the SS offices at the Auschwitz main camp. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0050-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Prisoners digging trenches for heating or plumbing pipes near the main reception building (Aufnahmegebaäude) in Auschwitz I. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0051-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Construction works by the main entrance to Birkenau, the photo taken from the internal part of the camp, possibly spring/summer 1943. In May 1944 Höss would supervise the laying of a railway line through the main entrance for Action Höss, the operation for transporting primarily Hungarian Jews to Birkenau. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0052-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0053-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Two photographs showing prisoners digging drainage ditches in Birkenau. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0053-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Prefabricated wooden stable barracks at B II of the Birkenau camp, winter 1943/4. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0054-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The construction of Crematorium IV taken by SS-man Kamann in late 1942. The architects signed off Crematorium IV on 22 March 1943 without having time to test the incinerators. After two weeks of intensive use the double four muffle furnace cracked. The incinerator was decommissioned in May 1943. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0054-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Taken in August 1942 showing SS-Sturmbannführer Karl Bischoff and SS-Untersturmführer Walter Dejaco, head of the drawing office, conferring with the aid of a blueprint in the initial stages of construction at the Crematoria IV and V sites. In the background civilian workers, probably from the firm Lenz & Co, which specialised in site-levelling work. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0055-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Höss (front row raised left arm) accompanies Himmler with engineer Faust and other officials to inspect the construction site of IG-Farben in Monowitz on 18 July 1942. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0056-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("SS sentries during a ceremony. In 1940 there were some 250 SS guards at Auschwitz-Birkenau; by March 1941 that figure had risen to 700; within three months it was around 2,000; in April 1944 the number was 2,950; in August, 3340; and by January 1945 it had reached 4,480. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0056-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The ramps of Birkenau have been cleared of Hungarian Jews and their belongings have been collected together. In the distance the twin chimneys of Crematoria II and III can be seen to the left and right of the two trains. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0057-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Between spring 1942 and mid-1944 this was the area where trains with deported Jews halted. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0058-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A transport from Subcarpathian Rus is taken off the trains and assembled on the ramp at Auschwitz-Birkenau. Many of these Jews were deported from Berehovo, where Jews from neighbouring towns and villages were gathered at a brick factory. This photograph is from the album, which includes 193 photographs mounted on 56 pages, of SS-Hauptscharführer Bernhardt Walter, head of the Auschwitz photographic laboratory known as the Erkennungsdienst (identification Service) and his assistant SS-Unterscharführer Ernst Hofmann. The album was produced as a presentation volume for the camp commandant. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0059-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jews from Subcarpathian Rus undergo a selection on the ramp at Auschwitz-Birkenau. Pictured in front holding a riding crop may be either SS Unterscharführer Wilhelm Emmerich or SS Hauptsturmführer Georg Höcker assisted by the Jewish prisoner Hans Schorr. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0059-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jews from Subcarpathian Rus undergo a selection on the ramp at Auschwitz-Birkenau in May 1944. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0060-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Newly arrived Jews from Subcarpathian Rus get off the train in Auschwitz-Birkenau. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0060-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jews from Subcarpathian Rus sit in a large group on the ramp at Auschwitz-Birkenau before undergoing the selection process. One of the crematoria is visible in the distance on the right. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0061-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A transport of Jews from Subcarpathian Rus is taken off the trains and assembled on the ramp at Auschwitz-Birkenau. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0062-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("SS guards supervise the arrival of a transport of Jews from Subcarpathian Rus to Auschwitz-Birkenau. Pictured on the far right is SS Wachmann Stefan Baretzki. Baretzki was conscripted into the SS and stationed at the Auschwitz concentration camp from 1942 until 1945. There he participated in mass murder by making selections, and was unrestrained in his beating of prisoners. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0062-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jewish women and children from Subcarpathian Rus who have been selected for death at Auschwitz-Birkenau wait to be taken to the gas chambers. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0063-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Babo Batren, an elderly Jewish woman from Tecso, leans against the deportation train in Auschwitz-Birkenau while waiting to be taken to the gas chambers. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_64"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0064-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jews from Subcarpathian Rus await selection on the ramp at Auschwitz-Birkenau. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0064-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jews from Subcarpathian Rus undergo a selection on the ramp at Auschwitz-Birkenau. The selection was often carried out by one or two SS medical doctors. The deportees were divided into four columns: two of women and children, and two of men. Those unfit for labour were sent straight to the crematoria, while the able-bodied workers were interned in Auschwitz, or were retained ready at a moment’s notice to be transferred to other camps in the Reich. The selection for labour in each transport varied daily; sometimes it was 10 per cent, sometimes it was 50 per cent. But most of the Jews that arrived through the gates of Birkenau were immediately sent to the ‘bathhouses’ to their deaths. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0065-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A group of religious Jews from Subcarpathian Rus wait on the ramp at Auschwitz-Birkenau. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0066-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jewish women and children who have been selected for death walk in a line towards the gas chambers. The gate at the upper left leads to the section of the camp on the south side of the ramp known as BI. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0066-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jewish women and children from Subcarpathian Rus who have been selected for death at Auschwitz-Birkenau wait to be taken to the gas chambers. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0067-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Two photographs showing Jewish women and children from Subcarpathian Rus who have been selected for death at Auschwitz-Birkenau walking to the gas chambers. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0067-02.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_68"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0068-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A transport of Jews from Subcarpathian Rus is taken off the trains and assembled on the ramp at Auschwitz-Birkenau. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_69"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0069-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jews from Subcarpathian Rus undergo a selection on the ramp at Auschwitz-Birkenau. SS officers regularly watched the shipments arrive and became morbidly fascinated by the spectacle. They witnessed the selection process at the unloading ramps and saw for themselves the awful scenes of families being torn apart and the separating of the men from the women and children. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0069-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jewish men from Subcarpathian Rus await selection on the ramp at Auschwitz-Birkenau. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0070-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jewish women and children from Subcarpathian Rus await selection on the ramp at Auschwitz-Birkenau. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_71"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0071-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jewish men from Subcarpathian Rus await selection on the ramp at Auschwitz-Birkenau. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0071-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jewish women and children from Subcarpathian Rus who have been selected for death at Auschwitz-Birkenau walk towards the gas chambers. The building in the background is Crematorium III. In May 1944 on average 3,300 Hungarian Jews arrived per day. On 20 May, for instance, one convoy arrived with 3,000 people, of whom some 1,000 were able and 2,000 were unable to work. The next day two convoys were reported to have arrived from Hungary with 6,000 people, of whom 2,000 were able to work and the remainder were sent directly to their deaths. That day both the incinerators of Crematoria II and III were being serviced so the victims from the transport were disposed of in the three incineration ditches next to Crematorium V. Though the specially built track from the crematorium to the pits had been laid it was never used because it was considered an inconvenience. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_72"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0072-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Two photographs showing disinfected and shorn female prisoners after leaving the Central Sauna. After being shorn, disinfected and showered under the surveillance of the SS, they were then given their disinfected and disinfested clothes and escorted to their designated barracks with a blanket for their bunk. Being shaved and stripped the new prisoners lost the last vestiges of their identity. They now all looked alike. "), _c('span', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Auschwitz-Birkenau Museum)")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0072-02.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3e0ac5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Chapter01.vue
// module id = 69
// module chunks = 0